import Head from "next/head";

type MetadataProps = {
  type: string;
  title: string;
  image: string;
  siteName: string;
  canonical: string;
  description: string;
  /** will use `title` as page's title if this is not provided */
  pageTitle?: string;
};

export default function Metadata(props: Partial<MetadataProps>) {
  const { type, title, description, image, siteName, canonical, pageTitle } = Object.assign(
    {
      type: "website",
      title: "Advante - Helping remote developers perform better at work",
      description:
        "Coaching and managing team members requires time and effort that you might not be able to give. Overall employee growth is vital to increase output and productivity, while adding to the workplace environment.",
      image: "https://advante.co/images/hero/ladies-on-laptop.webp",
      siteName: "Advante",
      canonical: "https://advante.co",
    },
    props,
  );

  return (
    <Head>
      <title>{pageTitle ?? title}</title>
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index,follow" />
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={[
          "Coaching",
          "Career coaching",
          "Leadership Coaching",
          "Performance Coaching",
          "Mental Health and Well-being Coaching",
          "Personal Development Coaching",
        ].join()}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@advanteco" />
      <meta name="twitter:creator" content="@highoutputhq" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Head>
  );
}
